'use strict';
import buttonModule from './button';
import tileModule from './tile';
import tileListControllerModule from './tileListController';
import tileListViewModule from './tileListView';
import scrollModule from './scroll';
import cinemaViewModule from './cinemaView';
import tracker from '../tracking/tracker';
import {CINEMAMODE} from "./dimensions";

const arrayFrom = (arrayLike) => {
    /*                                                                                       */
    return [].slice.call(arrayLike);
};

export default (cinemaDom, isExpandable, eventMergeId) => {
    const cinemaController = {};

    const updateButtonVisibility = () => {
        if (tileListController.isAtLeftBorder()) {
            leftButton.hide();
        } else {
            leftButton.show();
        }

        if (tileListController.isAtRightBorder()) {
            rightButton.hide();
        } else {
            rightButton.show();
        }
    };

    const performLayout = () => {
        return tileListController.updateTiles().then( (height) => {
            updateButtonVisibility();
            if (tileListController.cinemaMode() === CINEMAMODE.REDESIGN) {
                const containerHeight = tiles[0].domWrapper.imageContainerElement().clientHeight;
                leftButton.initializeButtonPosition(containerHeight, true);
                rightButton.initializeButtonPosition(containerHeight, true);
            } else {
                leftButton.initializeButtonPosition(height, false);
                rightButton.initializeButtonPosition(height, false);
            }
        });
    };

    const tiles = arrayFrom(cinemaDom.getElementsByClassName('auction_cinema__tile')).map((tileDom) => tileModule(tileDom));
    const tileListView = tileListViewModule(cinemaDom.getElementsByClassName('auction_cinema__tiles')[0], scrollModule());

    const auctionCinemaDom = cinemaDom.classList.contains('auction_cinema') ? cinemaDom : cinemaDom.getElementsByClassName('auction_cinema')[0];
    const cinemaView = cinemaViewModule(auctionCinemaDom);

    const tileListController = tileListControllerModule(tileListView, tiles, cinemaView, isExpandable);
    tileListController.registerScrollHandler();

    const leftButton = buttonModule(cinemaDom.getElementsByClassName('auction_cinema__button-left')[0]);
    leftButton.registerOnClickHandler(() => tileListController.scrollLeft(updateButtonVisibility));

    const rightButton = buttonModule(cinemaDom.getElementsByClassName('auction_cinema__button-right')[0]);
    rightButton.registerOnClickHandler(() => tileListController.scrollRight(updateButtonVisibility));

    buttonModule(cinemaDom.getElementsByClassName('auction_cinema_privacy__info')[0]);

    cinemaView.registerResizeHandler(performLayout);

    cinemaController.isLoaded = performLayout();
    cinemaController.performLayout = performLayout;

    tracker.trackView(cinemaView, tileListController.getAllVisibleTilesWithHalfVisibleTiles(), eventMergeId)

    cinemaController.getTileCount = tileListController.tileCount;
    cinemaController.getFirstTileIndex = tileListController.getFirstVisibleTileIndex;
    return cinemaController;
};